"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionReplayClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class SessionReplayClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseUrl = '/v1/session-replay';
    }
    getReplayLinksFromMatchingIds(matchingIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/get-replay-metadata`;
            const response = yield this.httpPost(url, { matchingIds });
            return response.payload;
        });
    }
    getPlayerToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/get-player-token`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSharedRecordingData(shareId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/shared-recording-data?shareId=${shareId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    monitorQuotas(projectId, monitorType, bucketCategory) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = this.getQueryString({ monitorType, bucketCategory });
            const url = `${this.baseUrl}/projects/${projectId}/monitor-quotas?${queryParams}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    setQuotas(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/projects/${request.projectId}/set-quotas`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    createSharedRecording(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, sessionReplayPlayerData } = request;
            const { userIdHashed, sessionNumber } = request.sessionReplayPlayerData;
            const url = `${this.baseUrl}/projects/${projectId}/visitors/${userIdHashed}/sessions/${sessionNumber}/pageviews/share`;
            const response = yield this.httpPost(url, { projectId, sessionReplayPlayerData });
            return response.payload;
        });
    }
    setQuotaLimitsNotifications(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/projects/${projectId}/quota-limits-notifications`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getQuotaLimitsNotifications(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/projects/${projectId}/quota-limits-notifications`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.SessionReplayClient = SessionReplayClient;
//# sourceMappingURL=session-replay.client.js.map